/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionTierSchema = z.enum(['lite', 'standard', 'pro', 'premium', 'enterprise', 'service'])

export type SubscriptionTierSchema = z.infer<typeof subscriptionTierSchema>
